import { shouldForwardProp, useTheme } from '@mui/system';
import { Box, InputAdornment, LinearProgress, OutlinedInput, Paper } from '@mui/material';
import { IconSearch } from '@tabler/icons';
import MainCard from 'ui-component/cards/MainCard';
import { styled } from '@mui/material/styles';
import { useState, useEffect } from 'react';
import { DependenciesList } from './Components/DependenciesList';
import DependencyService from './DependencyService';
//import { dependeciesHelper } from 'views/UsersManagement/DependenceHelper';

export const DependencyManagementView = () => {
  const theme = useTheme();
  const [isLoading, setLoading] = useState(true);
  const [dependecies, setDependecies] = useState([]);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    /*  dependeciesHelper.map(dependency => {
            let dep = {
                type: dependency.type,
                abbreviation: dependency.abbreviation,
                dependence: dependency.dependence,
                contact: '',
                format_1: '',
                format_2: ''
            }
            DependencyService.createDependency(dep);
        }) */

    setLoading(true);
    const handleDependencies = (data) => {
      setDependecies(data);
      setLoading(false);
    };
    const unsubscribe = DependencyService.subscribeToDependencies(handleDependencies);

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <div style={{ marginTop: '20px' }}>
      <MainCard
        title="Gestión Instituciones y/o Ministerios"
        secondary={
          <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            <OutlineInputStyle
              id="input-search-header"
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              placeholder="Buscar dependencia"
              startAdornment={
                <InputAdornment position="start">
                  <IconSearch stroke={1.5} size="1rem" color={theme.palette.grey[500]} />
                </InputAdornment>
              }
              aria-describedby="search-helper-text"
              inputProps={{ 'aria-label': 'weight' }}
            />
          </Box>
        }
        style={{ height: '100vh' }}
      >
        {isLoading && <LinearProgress />}
        <Paper style={{ maxHeight: '100vh', overflow: 'auto' }}>
          <DependenciesList dependecies={dependecies} filter={filter} />
        </Paper>
      </MainCard>
    </div>
  );
};

const OutlineInputStyle = styled(OutlinedInput, { shouldForwardProp })(({ theme }) => ({
  width: 434,
  marginLeft: 16,
  paddingLeft: 16,
  paddingRight: 16,
  '& input': {
    background: 'transparent !important',
    paddingLeft: '4px !important'
  },
  [theme.breakpoints.down('lg')]: {
    width: 250
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
    marginLeft: 4,
    background: '#fff'
  }
}));
